module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "p-day-one-reserving-simple"
  }, [(_vm.calculating) ? _c('div', {
    staticClass: "a-loader--big"
  }) : (!_vm.hasResults || _vm.dirtyForm) ? _c('div', [_c('h2', {
    staticClass: "u-margin-top-10 u-margin-bottom-10"
  }, [_vm._v("Your Results")]), _vm._v(" "), _c('p', [_vm._v("Your results will appear here once all mandatory fields have been completed and you have calculated\n          the result.")])]) : _c('div', [_c('accordion', [_c('accordion-item', {
    attrs: {
      "show-open": ""
    }
  }, [_c('h2', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("Facts & Figures")]), _vm._v(" "), _c('table', {
    staticClass: "a-table u-full-width"
  }, [_c('tr', [_c('td', [_vm._v("Deceased's age at DOD")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "150"
    }
  }, [_vm._v(_vm._s(_vm.roundValue(_vm.ageAtDeath, 2)))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Period between DOD & Assessment")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundValue(_vm.results.calculation.periodBetweenDodAndAssessment, 2)) + " years")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Deceased's age at Assessment/Trial")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundValue(_vm.results.calculation.deceasedAgeAtAssessment, 2)) + " years")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n                            Period of Dependency from Assessment/Trial (Based on Deceased's assumed life expectancy\n                            at age of Assessment/Trial — Column 0% Ogden Table 1)\n                        ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundValue(_vm.results.calculation.periodOfDependencyFromAssessment, 2)) + " years")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Ogden Discount Rate")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.results.calculation.ogdenDiscountRate) + "%")])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
    staticClass: "u-d-flex u-flex-space-between"
  }, [_vm._v("\n                                Ogden Table 36 multiplier dependency\n                                "), _c('calculation-modal', {
    attrs: {
      "name": "dayOneTable28Multiplier",
      "type": "fatal"
    }
  }, [_c('icon-tooltip', {
    attrs: {
      "icon-type": "info",
      "tooltip-text": "Click to view calculations",
      "side": "right",
      "text-width": "140"
    }
  })], 1)], 1)]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundValue(_vm.results.calculation.table28Multiplier, 2)))])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
    staticClass: "u-d-flex u-flex-space-between"
  }, [_vm._v("\n                                Table E pre-assessment discount\n                                "), _c('calculation-modal', {
    attrs: {
      "name": "dayOneTableEDiscount",
      "type": "fatal"
    }
  }, [_c('icon-tooltip', {
    attrs: {
      "icon-type": "info",
      "tooltip-text": "Click to view calculations",
      "side": "right",
      "text-width": "140"
    }
  })], 1)], 1)]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundValue(_vm.results.calculation.preAssessmentDiscount, 2)))])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
    staticClass: "u-d-flex u-flex-space-between"
  }, [_vm._v("\n                                Table F post-assessment discount\n                                "), _c('calculation-modal', {
    attrs: {
      "name": "dayOneTableFDiscount",
      "type": "fatal"
    }
  }, [_c('icon-tooltip', {
    attrs: {
      "icon-type": "info",
      "tooltip-text": "Click to view calculations",
      "side": "right",
      "text-width": "140"
    }
  })], 1)], 1)]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundValue(_vm.results.calculation.postAssessmentDiscount, 2)))])])])]), _vm._v(" "), _c('div', {
    staticClass: "u-position-relative"
  }, [_c('accordion-item', [_c('h2', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("Assumptions")]), _vm._v(" "), _c('div', {
    staticClass: "p-day-one__tooltip-modal"
  }, [_c('modal-in-the-wild', {
    attrs: {
      "modal-name": "assumptions_overview"
    }
  }, [_c('icon-tooltip', {
    attrs: {
      "icon-type": "info",
      "tooltip-text": "Click to view assumptions",
      "side": "right",
      "text-width": "140"
    }
  })], 1)], 1), _vm._v(" "), _c('ul', {
    staticClass: "p-day-one__tooltip-modal--assumptions-list"
  }, [_c('li', [_vm._v("\n                            Deceased had normal life expectancy as per the 0% column Ogden Table\n                            " + _vm._s(_vm.gender === 'male' ? 1 : 2) + "\n                        ")]), _vm._v(" "), (_vm.estateOrDependency != 'estate') ? _c('div', [_c('li', [_vm._v("Any dependent(s) would have outlived the deceased")]), _vm._v(" "), _c('li', [_vm._v("\n                                The deceased’s ‘but for’ life expectancy determines the end of\n                                dependency\n                            ")]), _vm._v(" "), _c('li', [_vm._v("Cost of past services is calculated from onset of symptoms to date of death")]), _vm._v(" "), _c('li', [_vm._v("Cost of past services assessed at £1,500 per annum")])]) : _vm._e(), _vm._v(" "), (_vm.employmentType === 'employed') ? _c('li', [_vm._v("\n                            The deceased will retire as the state pension age. As the deceased was born on\n                            " + _vm._s(_vm.dateOfBirth) + " this is\n                            assumed to be on " + _vm._s(_vm.results.calculation.retirementDate) + " at age " + _vm._s(_vm.retirementAge) + "\n                        ")]) : _vm._e(), _vm._v(" "), _c('li', [_vm._v("Past loss of earnings will commence in full from the date of onset of symptoms")]), _vm._v(" "), (_vm.estateOrDependency != 'estate') ? _c('li', [_vm._v("\n                            Bereavement award based on date of death would apply\n                        ")]) : _vm._e(), _vm._v(" "), _c('li', [_vm._v("Typical heads of loss are applied as follows:\n                            "), _c('ul', {
    staticClass: "sub"
  }, [_c('li', [_vm._v("General damages (PSLA) " + _vm._s(_vm.currencyFormat(_vm.results.damages.generalDamages)))]), _vm._v(" "), _c('li', [_vm._v("Care " + _vm._s(_vm.currencyFormat(_vm.results.damages.care)))]), _vm._v(" "), _c('li', [_vm._v("Funeral expenses " + _vm._s(_vm.currencyFormat(_vm.results.damages.funeralExpenses)))]), _vm._v(" "), _c('li', [_vm._v("\n                                    Miscellaneous (medication, travel, appliances, additional food & energy\n                                    costs) " + _vm._s(_vm.currencyFormat(_vm.results.damages.miscellaneous)) + "\n                                ")])])]), _vm._v(" "), (_vm.estateOrDependency != 'estate') ? _c('div', [_c('li', [_vm._v("The dependency multiplier is based on Ogden Table 36")]), _vm._v(" "), _c('li', [_vm._v("The dependency multiplicand on services is assesed at £1,500")]), _vm._v(" "), _c('li', [_vm._v("\n                                Future dependency on services is determined from date of death to the deceased's\n                                \"but for\" life expectancy\n                            ")]), _vm._v(" "), _c('li', [_vm._v("All dependants have no earnings")]), _vm._v(" "), _c('li', [_vm._v("Dependency on pension is assessed at £10,000 per annum")])]) : _vm._e()])])], 1), _vm._v(" "), _c('div', {
    staticClass: "u-position-relative"
  }, [_c('accordion-item', [_c('h2', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("Total Damages")]), _vm._v(" "), _c('div', {
    staticClass: "a-table--short-no-style"
  }, [_c('table', {
    staticClass: "a-table u-full-width"
  }, [_c('tbody', [_c('tr', [_c('th', [_vm._v("Heads of Loss")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Valuation")])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
    staticClass: "u-d-flex u-flex-space-between"
  }, [_vm._v("\n                                        General Damages (PSLA)\n                                    ")])]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('div', {
    staticClass: "a-form-inputs--pound"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.generalDamages),
      expression: "generalDamages",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.generalDamages)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.generalDamages = _vm._n($event.target.value)
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])])]), _vm._v(" "), (_vm.estateOrDependency != 'estate') ? _c('tr', [_c('td', [_c('div', {
    staticClass: "u-d-flex u-flex-space-between"
  }, [_vm._v("\n                                        Bereavement Award\n                                        "), _c('calculation-modal', {
    attrs: {
      "name": "dayOneBereavementAward",
      "type": "fatal"
    }
  }, [_c('icon-tooltip', {
    attrs: {
      "icon-type": "info",
      "tooltip-text": "Click to view calculations",
      "side": "right",
      "text-width": "140"
    }
  })], 1)], 1)]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.currencyFormat(_vm.results.damages.bereavementAward)))])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
    staticClass: "u-d-flex u-flex-space-between"
  }, [_vm._v("\n                                        Funeral Expenses\n                                        "), _c('calculation-modal', {
    attrs: {
      "name": "dayOneFuneralExpenses",
      "type": "fatal"
    }
  }, [_c('icon-tooltip', {
    attrs: {
      "icon-type": "info",
      "tooltip-text": "Click to view calculations",
      "side": "right",
      "text-width": "140"
    }
  })], 1)], 1)]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.currencyFormat(_vm.results.damages.funeralExpenses)))])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
    staticClass: "u-d-flex u-flex-space-between"
  }, [_vm._v("\n                                        Past Loss of Earnings (if applicable)\n                                        "), _c('calculation-modal', {
    attrs: {
      "name": "dayOnePastLossOfEarnings",
      "type": "fatal"
    }
  }, [_c('icon-tooltip', {
    attrs: {
      "icon-type": "info",
      "tooltip-text": "Click to view calculations",
      "side": "right",
      "text-width": "140"
    }
  })], 1)], 1)]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.currencyFormat(_vm.results.damages.pastLossOfEarnings)))])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
    staticClass: "u-d-flex u-flex-space-between"
  }, [_vm._v("\n                                        Past Cost of DIY/Services\n                                        "), _c('calculation-modal', {
    attrs: {
      "name": "dayOnePastCostOfServices",
      "type": "fatal"
    }
  }, [_c('icon-tooltip', {
    attrs: {
      "icon-type": "info",
      "tooltip-text": "Click to view calculations",
      "side": "right",
      "text-width": "140"
    }
  })], 1)], 1)]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.currencyFormat(_vm.results.damages.pastCostOfDiy)))])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
    staticClass: "u-d-flex u-flex-space-between"
  }, [_vm._v("\n                                        Miscellaneous (treatments/increased utilities/clothing/foods/appliances &\n                                        equipment)\n                                        "), _c('calculation-modal', {
    attrs: {
      "name": "dayOneMiscellaneousCalc",
      "type": "fatal"
    }
  }, [_c('icon-tooltip', {
    attrs: {
      "icon-type": "info",
      "tooltip-text": "Click to view calculations",
      "side": "right",
      "text-width": "140"
    }
  })], 1)], 1)]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.currencyFormat(_vm.results.damages.miscellaneous)))])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
    staticClass: "u-d-flex u-flex-space-between"
  }, [_vm._v("\n                                        Care\n                                        "), _c('calculation-modal', {
    attrs: {
      "name": "dayOneCostOfCare",
      "type": "fatal"
    }
  }, [_c('icon-tooltip', {
    attrs: {
      "icon-type": "info",
      "tooltip-text": "Click to view calculations",
      "side": "right",
      "text-width": "140"
    }
  })], 1)], 1)]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.currencyFormat(_vm.results.damages.care)))])]), _vm._v(" "), (_vm.estateOrDependency != 'estate') ? _c('tr', [_c('td', [_c('div', {
    staticClass: "u-d-flex u-flex-space-between"
  }, [_vm._v("\n                                        Dependency on Income\n                                        "), _c('calculation-modal', {
    attrs: {
      "name": "dayOneDependencyOnIncome",
      "type": "fatal"
    }
  }, [_c('icon-tooltip', {
    attrs: {
      "icon-type": "info",
      "tooltip-text": "Click to view calculations",
      "side": "right",
      "text-width": "140"
    }
  })], 1)], 1)]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.currencyFormat(_vm.results.damages.dependencyOnIncome)))])]) : _vm._e(), _vm._v(" "), (_vm.estateOrDependency != 'estate') ? _c('tr', [_c('td', [_c('div', {
    staticClass: "u-d-flex u-flex-space-between"
  }, [_vm._v("\n                                        Dependency on Services\n                                        "), _c('calculation-modal', {
    attrs: {
      "name": "dayOneDependencyOnServices",
      "type": "fatal"
    }
  }, [_c('icon-tooltip', {
    attrs: {
      "icon-type": "info",
      "tooltip-text": "Click to view calculations",
      "side": "right",
      "text-width": "140"
    }
  })], 1)], 1)]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.currencyFormat(_vm.results.damages.dependencyOnServices)))])]) : _vm._e()]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "colspan": "3"
    }
  }, [_c('button', {
    staticClass: "a-button",
    on: {
      "click": _vm.addHeadOfLoss
    }
  }, [_vm._v("\n                                        " + _vm._s(_vm.ownHeadsOfLoss.length ?
    'Add another head of loss' : 'Click here to add your own head of loss') + "\n                                    ")])])]), _vm._v(" "), _vm._l((_vm.ownHeadsOfLoss), function(head, index) {
    return _c('own-head-of-loss', {
      attrs: {
        "head-of-loss": head,
        "index": index
      }
    })
  })], 2), _vm._v(" "), _c('tfoot', [_c('tr', [_c('td', [_vm._v("Total Damages")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.currencyFormat(_vm.totalDamages)))])])])])])])], 1), _vm._v(" "), _c('accordion-item', [_c('h2', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("Total Reserve")]), _vm._v(" "), _c('table', {
    staticClass: "a-table u-full-width"
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("Total Damages")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.currencyFormat(_vm.totalDamages)))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Claimant Costs")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('div', {
    staticClass: "a-form-inputs--pound"
  }, [_c('input', {
    directives: [{
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "type": "number",
      "min": "0"
    },
    domProps: {
      "value": _vm.claimantCosts
    },
    on: {
      "input": _vm.updateClaimantCosts
    }
  })])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Defence Costs")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('div', {
    staticClass: "a-form-inputs--pound"
  }, [_c('input', {
    directives: [{
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "type": "number",
      "min": "0"
    },
    domProps: {
      "value": _vm.defenceCosts
    },
    on: {
      "input": _vm.updateDefenceCosts
    }
  })])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("% Contribution to Damages")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('input', {
    attrs: {
      "type": "number",
      "min": "0",
      "max": "100"
    },
    domProps: {
      "value": _vm.damagesContribution
    },
    on: {
      "input": _vm.updateDamagesContribution
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("% Contribution to Claimant Costs")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('input', {
    attrs: {
      "type": "number",
      "min": "0",
      "max": "100"
    },
    domProps: {
      "value": _vm.claimantContribution
    },
    on: {
      "input": _vm.updateClaimantContribution
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("% Contribution to Defence Costs")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('input', {
    attrs: {
      "type": "number",
      "min": "0",
      "max": "100"
    },
    domProps: {
      "value": _vm.defenceContribution
    },
    on: {
      "input": _vm.updateDefenceContribution
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Damages Reserve (Apportioned)")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.currencyFormat(_vm.apportionedDamagesReserve)))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Claimant Costs (Apportioned)")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.currencyFormat(_vm.apportionedClaimantReserve)))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Defence Costs (Apportioned)")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.currencyFormat(_vm.apportionedDefenceReserve)))])])]), _vm._v(" "), _c('tfoot', [_c('tr', {}, [_c('td', [_vm._v("Total Reserve")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.currencyFormat(_vm.totalReserve)))])])])])]), _vm._v(" "), _c('accordion-item', [_c('h2', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("Compare Your Claim")]), _vm._v(" "), _c('div', {
    staticClass: "p-day-one-reserving-simple__compare-your-claim"
  }, [_c('modal-in-the-wild', {
    attrs: {
      "modal-name": "compare_your_claim"
    }
  }, [_c('icon-tooltip', {
    attrs: {
      "icon-type": "info",
      "tooltip-text": "Click to view compare details",
      "side": "right",
      "text-width": "140"
    }
  })], 1)], 1), _vm._v(" "), _c('reserve-performance-chart', {
    attrs: {
      "slot": "if-slot"
    },
    slot: "if-slot"
  })], 1)], 1), _vm._v(" "), _c('day-one-save'), _vm._v(" "), (_vm.exists) ? _c('button', {
    staticClass: "a-button",
    on: {
      "click": _vm.openSummaryDocument
    }
  }, [_vm._v("\n            Download Summary\n        ")]) : _vm._e(), _vm._v(" "), _c('modal', {
    attrs: {
      "name": "assumptions_overview",
      "no-default-button": "true"
    }
  }, [_c('h1', [_vm._v("Assumptions")]), _vm._v(" "), _c('accordion', [_c('past-services-modal', {
    attrs: {
      "value": _vm.results.damages.pastCostOfDiy
    }
  }), _vm._v(" "), _c('past-loss-earnings-modal', {
    attrs: {
      "value": _vm.results.damages.pastLossOfEarnings
    }
  }), _vm._v(" "), (_vm.estateOrDependency !== 'estate') ? _c('bereavement-award-modal', {
    attrs: {
      "person": _vm.modalPayload.person,
      "value": _vm.results.damages.bereavementAward
    }
  }) : _vm._e(), _vm._v(" "), _c('psla-modal', {
    attrs: {
      "age": _vm.ageAtDeath,
      "duration": _vm.durationOfSymptoms,
      "value": _vm.results.damages.generalDamages
    }
  }), _vm._v(" "), _c('care-modal', {
    attrs: {
      "value": _vm.results.damages.care,
      "person": _vm.modalPayload.person,
      "claim": _vm.modalPayload.claim,
      "type": _vm.estateOrDependency
    }
  }), _vm._v(" "), _c('funeral-expenses-modal', {
    attrs: {
      "value": _vm.results.damages.funeralExpenses
    }
  }), _vm._v(" "), _c('misc-modal', {
    attrs: {
      "value": _vm.results.damages.miscellaneous
    }
  }), _vm._v(" "), (_vm.estateOrDependency != 'estate') ? _c('dependency-income-modal', {
    attrs: {
      "value": _vm.results.damages.dependencyOnIncome
    }
  }) : _vm._e(), _vm._v(" "), (_vm.estateOrDependency != 'estate') ? _c('dependency-services-modal', {
    attrs: {
      "value": _vm.results.damages.dependencyOnServices
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('modal', {
    attrs: {
      "name": "calculation_modal",
      "no-default-button": "true"
    }
  }, [_c('modal-content')], 1), _vm._v(" "), _c('modal', {
    attrs: {
      "name": "psla_modal",
      "no-default-button": "true"
    }
  }, [_c('h2', [_vm._v("\n                General Damages\n            ")]), _vm._v(" "), _c('psla-modal-content', {
    attrs: {
      "age": _vm.ageAtDeath,
      "duration": _vm.durationOfSymptoms,
      "value": _vm.results.damages.generalDamages
    }
  })], 1), _vm._v(" "), _c('modal', {
    attrs: {
      "name": "compare_your_claim",
      "no-default-button": "true"
    }
  }, [_c('h2', [_vm._v("\n                Compare your claims\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n                Using the information you have provided we have attempted to match claims with similar\n                characteristics\n                from your book of claims.\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n                To determine a match we have looked for claims that match:\n            "), _c('ul', [_c('li', [_vm._v("Disease type: "), _c('span', {
    staticClass: "u-bold"
  }, [_vm._v(_vm._s(_vm.diseaseType))])]), _vm._v(" "), _c('li', [_vm._v("Claim type: "), _c('span', {
    staticClass: "u-bold"
  }, [_vm._v("Fatal Accident")])]), _vm._v(" "), _c('li', [_vm._v("Estate or Dependency:\n                    "), _c('span', {
    staticClass: "u-bold"
  }, [_vm._v(_vm._s(_vm.estateOrDependency === 'dependency' ? 'Dependency' : 'Estate Only'))])]), _vm._v(" "), _c('li', [_vm._v("Deceased Gender: "), _c('span', {
    staticClass: "u-bold"
  }, [_vm._v(_vm._s(_vm.gender === 'male' ? 'Male' : 'Female'))])]), _vm._v(" "), _c('li', [_vm._v("Deceased age (in five years bracket going up):\n                    "), _c('span', {
    staticClass: "u-bold"
  }, [_vm._v(_vm._s(_vm.ageAtDeath))]), _vm._v(" to "), _c('span', {
    staticClass: "u-bold"
  }, [_vm._v(_vm._s(parseInt(_vm.ageAtDeath) + 4))])])])])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-65958019!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/reserving/day-one/fatal/Results.vue
// module id = 1724
// module chunks = 0